import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function ZigbeeNodeEndpointGroups(props) {
    var _a;
    const ts = (_a = props.groups) === null || _a === void 0 ? void 0 : _a.fetched_ts;
    const last_fetched = ts == undefined ? '?' : (new Date(ts).toLocaleString());
    const title = 'Groups (' + last_fetched + ')';
    const rows = [];
    if (props.groups != undefined) {
        for (const g of props.groups.items) {
            rows.push(_jsx("div", { children: g.id }, g.id));
        }
    }
    return (_jsxs(_Fragment, { children: [_jsxs("h3", { children: [title, "\u00A0\u00A0", _jsx("button", { type: "button", onClick: () => props.onFetchEndpointGroups(), children: "\uD83D\uDDD8" })] }), rows] }));
}
